import { toast } from 'react-toastify'
import { Button } from 'reactstrap'
import { RestoreNotificationsParams } from '../../api/notifications/types'
import i18n from '../../i18n'

export const showDismissUndoToast = (deliveryIds: number[], restoreNotification: (params: RestoreNotificationsParams) => void) => {
    toast.info(
        ({ closeToast }) => (
            <span>
                {`${i18n.t('notification.toast.dismissed')}:`}{' '}
                <Button
                    color="link"
                    className="p-0 align-middle"
                    onClick={() => {
                        restoreNotification({ deliveryIds })
                        closeToast()
                    }}
                >
                    {i18n.t('button.undo') as string}
                </Button>
            </span>
        ),
        { autoClose: 5000 }
    )
}
